import {
  FlexColumn,
  FlexRow,
  LoaderBar,
  PrimaryEditButton,
  ScreenHeader,
} from 'components'
import { GetCompetitionById, GetRoundsByCompetition } from 'hooks'
import React, { useMemo, useState } from 'react'
import { useNavigate, useParams } from 'react-router-dom'
import { HeaderWrapper } from '../dashboard'
import {
  Participants,
  // RemovedParticipantsList,
  RoundBoxList,
  RulesAndGuidelines,
  StatusBox,
} from 'page-components'
import styled from 'styled-components'
import { CompetitionDetailsTabs, DateUtility } from 'utility'
import { Tabs } from 'antd'
import { PencilSimpleLine } from 'phosphor-react'

const InfoLabel = styled.span`
  font-weight: 400;
  color: #4c4c4c;
  margin-right: 4px;
`

export const CompetitionDetailScreen = () => {
  const [tab, setTab] = useState(CompetitionDetailsTabs.Rounds)
  const { id } = useParams()
  const { data, loading } = GetCompetitionById(id)
  const { data: rounds } = GetRoundsByCompetition(id)
  const navigate = useNavigate()

  const items = useMemo(
    () => [
      {
        key: CompetitionDetailsTabs.Rounds,
        label: 'Rounds',
        children: (
          <RoundBoxList
            competitionName={data?.name}
            competitionId={id}
            list={rounds}
          />
        ),
      },
      {
        key: CompetitionDetailsTabs.RulesAndGuidelines,
        label: 'Rules & Guidelines',
        children: <RulesAndGuidelines rules={data?.rules} />,
      },
      {
        key: CompetitionDetailsTabs.Participants,
        label: 'Participants',
        children: <Participants id={id} />,
      },
      // {
      //   key: CompetitionDetailsTabs.RemovedParticipants,
      //   label: 'Removed Participants',
      //   children: <RemovedParticipantsList />,
      // },
    ],
    [rounds, data],
  )

  return (
    <div>
      <div>
        <HeaderWrapper>
          <ScreenHeader
            text={
              <FlexRow>
                <span className="me-3">{data?.name}</span>
                <StatusBox competition={data?.status} />
              </FlexRow>
            }
          />
          <PrimaryEditButton
            className=""
            onClick={() => navigate(`/app/competitions/add-edit/${id}`)}
          >
            <PencilSimpleLine size={20} color="#2454ff" /> Edit
          </PrimaryEditButton>
        </HeaderWrapper>
      </div>
      {loading && <LoaderBar />}
      <div className="px-5 my-4 mt-3">
        <FlexRow className="">
          <InfoLabel>Start Date:</InfoLabel>
          <strong className="mx-1">
            {DateUtility.formatDate(new Date(data.start_date))}
          </strong>{' '}
          <InfoLabel> - End Date:</InfoLabel>
          {'  '}
          <strong className="mx-1">
            {DateUtility.formatDate(new Date(data.end_date))}
          </strong>
        </FlexRow>
        <FlexColumn className="mt-3">
          <InfoLabel>Description</InfoLabel>
          <p>{data.description}</p>
        </FlexColumn>
      </div>
      <div className="px-5">
        <div className="tabs-container">
          <Tabs
            defaultActiveKey="1"
            activeKey={tab}
            items={items}
            className="custom-tabs"
            centered
            onChange={key => setTab(key)}
          />
        </div>
      </div>
    </div>
  )
}
